module.exports = __webpack_public_path__ + "img/kline_krbs_logo.04dd0982.jpg";